// removed by extract-text-webpack-plugin
module.exports = {"review-paper":"src-components----Review-module---review-paper---2Yl1x","review-container":"src-components----Review-module---review-container---3gPjg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Review.module.css
// module id = 992
// module chunks = 35783957827783